import { useMemo } from 'react';

import { Box, Flex, Text } from '@chakra-ui/layout';
import { Trans } from '@lingui/macro';
import { IoMdTrash } from 'react-icons/io';

import { COMMON_PADDING } from '../../../utils/styleUtil';
import BorderLeftBox from '../../generic/BorderLeftBox';
import ButtonDelete from '../../generic/button/ButtonDelete';
import HDivider from '../../generic/HDivider';
import FlexRow from '../../generic/layout/FlexRow';
import AvailabilityDateTime from '../availability/AvailabilityDateTime';
import AvailabilityMoreDates from '../availability/AvailabilityMoreDates';
import ProductProviderTag from '../product/tags/ProductProviderTag';
import SessionVariantSelectedStaff from './SessionVariantSelectedStaff';

const SessionVariantsProduct = ({ product, availabilities, sameSessionIndex = 0, onRemoveSameSession }) => {
  const { title: productTitle } = product;
  const isFirstSessionBloc = sameSessionIndex === 0;

  const { sessionGroupIds, nbSessions } = useMemo(() => getAllSelectedSessions(availabilities), [JSON.stringify(availabilities)]);

  return (
    <>
      <Box bg="brand.background_main" p={COMMON_PADDING} pt={{ base: '0', md: undefined }}>
        {isFirstSessionBloc && availabilities.length <= 1 && <Text fontSize="xl">{productTitle}</Text>}
        {isFirstSessionBloc && availabilities.length > 1 && (
          <Text fontSize="xl">
            {productTitle} (x{availabilities.length})
          </Text>
        )}

        {isFirstSessionBloc && product.team && <ProductProviderTag providerName={product.team.name} mb="15px" />}

        {!isFirstSessionBloc && (
          <HDivider fontSize="sm" fontWeight="500" minW="fit-content">
            <Trans>Session&nbsp;{sameSessionIndex + 1}</Trans>
          </HDivider>
        )}

        <FlexRow>
          <Box>
            <BorderLeftBox>
              <AvailabilityDateTime sessions={availabilities} />
              <AvailabilityMoreDates sessionGroupIds={sessionGroupIds} nbSessions={nbSessions} />
              <SessionVariantSelectedStaff />
            </BorderLeftBox>
          </Box>
          <Flex flexGrow="1" justifyContent="flex-end" alignItems="center">
            {!isFirstSessionBloc && <ButtonDelete onClick={onRemoveSameSession} position="relative" defaultIcon={IoMdTrash} enableSpinner={false} />}
          </Flex>
        </FlexRow>
      </Box>
    </>
  );
};

export default SessionVariantsProduct;

const getAllSelectedSessions = availabilities => {
  const sessionGroupIds = [];
  let nbSessions = 0;

  for (const ava of availabilities) {
    sessionGroupIds.push(ava.session_group_id);
    nbSessions += parseInt(ava.nb_sessions);
  }
  return { sessionGroupIds, nbSessions };
};
